import { EC2, VM } from "@/icons"

import type { VmIconsProps } from "."

export const VmIcons = ({ type, ...props }: VmIconsProps) =>
  type === "EC2" ? <EC2 {...props} /> : <VM {...props} />
